import React from "react";
import ToolTip from "./ToolTip";

const TutorialPopup = (props) => {
  return (
    <ToolTip content={props.content} className="wide-tooltip">
      <i
        className="far fa-question-circle"
        style={{ fontSize: 12, marginLeft: 5 }}
      ></i>
    </ToolTip>
  );
};

export default TutorialPopup;
